var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { parseQueryString, deprecationWarning } from '@navinc/utils';
const FeatureContext = createContext();
export const FeatureProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    deprecationWarning(true, 'the <Feature/> and <FeatureProvider /> components are deprecated.');
    return _jsx(FeatureContext.Provider, Object.assign({}, props, { children: children }));
};
export const Feature = ({ children, name = '', search = '' }) => {
    deprecationWarning(true, 'the <Feature/> and <FeatureProvider /> components are deprecated.');
    const featureContext = useContext(FeatureContext);
    if (featureContext === undefined) {
        throw new Error('Feature must be used within a FeatureProvider');
    }
    const queryParams = parseQueryString(search);
    const features = Object.assign(Object.assign({}, featureContext), queryParams);
    const isOn = ['true', true].includes(features[name]);
    if (!isOn)
        return null;
    return children;
};
//# sourceMappingURL=index.js.map